import React, { useMemo } from "react";

const PALETTE = [
  "#0F40AE", "#16A34A", "#D97706", "#0891B2", "#DC2626",
  "#7C3AED", "#DB2777", "#059669",
];

const TopCategoriesChart = ({ data }) => {
  const max = useMemo(() => Math.max(...(data?.map((d) => d.count) ?? [1]), 1), [data]);

  if (!data?.length) {
    return (
      <div className="flex items-center justify-center h-20 text-gray-400 text-xs">
        No category data available
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      {data.map((cat, i) => {
        const pct = (cat.count / max) * 100;
        const color = PALETTE[i % PALETTE.length];
        return (
          <div key={cat.name} className="flex items-center gap-3">
            {/* Rank */}
            <span className="text-[10px] text-gray-400 font-mono w-4 text-right flex-shrink-0">
              {i + 1}
            </span>
            {/* Label */}
            <span className="text-xs text-gray-600 font-medium w-36 truncate flex-shrink-0">
              {cat.name}
            </span>
            {/* Bar */}
            <div className="flex-1 h-5 bg-gray-50 rounded-md overflow-hidden relative">
              <div
                className="h-full rounded-md transition-all"
                style={{ width: `${pct}%`, backgroundColor: color, opacity: 0.85 }}
              />
            </div>
            {/* Count */}
            <span
              className="text-xs font-bold w-8 text-right flex-shrink-0"
              style={{ color }}
            >
              {cat.count}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TopCategoriesChart;
